/**
 * Where a page's back arrow goes (#278): the previous page of the app, or `fallback` when the
 * page was opened directly - a link from an email, a bookmark, a typed URL - and the step back
 * would leave the site or reload the same page.
 *
 * React Router keeps the position of the current entry in `history.state.idx`: 0 for the entry
 * the app was loaded on, one more for every navigation inside it.
 *
 * @param {object | null | undefined} historyState `window.history.state`.
 * @param {string} fallback e.g. "/Home".
 * @returns {number | string} -1 for navigate(-1), else the path to open.
 */
export const backTarget = (historyState, fallback) =>
  (historyState?.idx ?? 0) > 0 ? -1 : fallback;
